var UserPlugin={
    getRole:function(){
        var role=localStorage.getItem('roleToken');
        if(role){
            return role;
        }else{
            return 0;
        }
    }
};

export default function(Vue){
    Vue.role=UserPlugin;

    Object.defineProperties(Vue.prototype, {
        $role:{
            get:function(){
                return Vue.role;
            }
        }
    })
}


// WEBPACK FOOTER //
// ./src/plugins/RolUser.js